var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWait72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 4c13.255 0 24 10.745 24 24S41.255 52 28 52a23.94 23.94 0 0 1-17.887-7.998A1.5 1.5 0 0 1 12.348 42 20.94 20.94 0 0 0 28 49c11.598 0 21-9.402 21-21S39.598 7 28 7a20.96 20.96 0 0 0-16.494 8H16.5c1.944 0 1.998 2.836.162 2.993L16.5 18H8a1.5 1.5 0 0 1-1.493-1.356L6.5 16.5V8a1.5 1.5 0 0 1 2.993-.144L9.5 8v4.71A23.956 23.956 0 0 1 28 4zm0 12a1.5 1.5 0 0 1 1.493 1.356l.007.144v9.879l6.06 6.06a1.5 1.5 0 0 1 .104 2.008l-.103.114a1.5 1.5 0 0 1-2.008.103l-.114-.103-6.5-6.5a1.5 1.5 0 0 1-.432-.913L26.5 28V17.5A1.5 1.5 0 0 1 28 16z",
    fill: "currentColor"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait72);
export default __webpack_public_path__ + "static/media/wait_72.63ba51d4.svg";
export { ForwardRef as ReactComponent };